import EventEmitter from 'eventemitter3';

/**
 * Um objeto EventEmitter para lidar com eventos personalizados.
 */
const emitter = new EventEmitter();

export default emitter;
